<template>
  <v-card
    outlined
    class="px-6 mt-6 pb-6"
  >
    <div class="d-flex flex-row justify-space-between">
      <label class="subtitle-1 grey--text pb-3 pt-1 mt-4">FAQs</label>
    </div>
    <v-card
      class="withdrawal-options mb-3"
      color="grey lighten-3"
      :key="i"
      v-for="(faq, i) in faqs"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              dense
              flat
              placeholder="Question"
              solo
              v-model="faqs[i].question"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <content-editor v-model="faqs[i].answer" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <b
          @click="removeFAQ(i)"
          class="text-caption font-weight-bold header-btns"
        >remove</b>
      </v-card-actions>
    </v-card>
    <b
      @click="addFAQ"
      class="text-caption font-weight-bold header-btns"
    >Add FAQ
    </b>
  </v-card>
</template>

<script>
import ContentEditor from '@/components/ContentEditor'

export default {
  name: 'Faqs',
  components: {
    ContentEditor
  },
  props: {
    faqs: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    addFAQ () {
      this.faqs.push(
        {
          question: '',
          answer: ''
        }
      )
    },
    removeFAQ (i) {
      this.faqs.splice(i, 1)
    }
  }
}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}
</style>
